"use client";

import { useEffect } from "react";

import { RENAMED_CONFIG_FOLDERS } from "@/shared/group-configs/renamed-subdomains";
import { useToast } from "@/src/hooks/use-toast";
import { ROOT_DOMAIN } from "@/src/lib/preview-env";

// The same renames the proxy redirects on, inverted to look up by the subdomain we are now serving.
const LEGACY_SUBDOMAIN_BY_NEW_SUBDOMAIN: Record<string, string> = Object.fromEntries(
  Object.entries(RENAMED_CONFIG_FOLDERS).map(([legacySubdomain, currentSubdomain]) => [
    currentSubdomain,
    legacySubdomain,
  ])
);

// Caps the notice at once per tab, cleared on logout
// TODO: Anyone reading this after October 21, 2026 - please remove LegacyHostNotice altogether
const NOTICE_SHOWN_SESSION_KEY = "vh_legacy_host_notice";

export function clearLegacyHostNotice(): void {
  sessionStorage.removeItem(NOTICE_SHOWN_SESSION_KEY);
}

/**
 * Tells members of a renamed tenant that its address changed, so bookmarks and saved links get
 * updated. Mounted on the login page and the dashboard layout, so it reaches members arriving on a
 * stale bookmark whether or not they still have a session. Renders nothing itself.
 */
export function LegacyHostNotice() {
  const { toast } = useToast();

  useEffect(() => {
    const subdomain = window.location.hostname.split(".")[0];
    const legacySubdomain = subdomain ? LEGACY_SUBDOMAIN_BY_NEW_SUBDOMAIN[subdomain] : undefined;

    if (!legacySubdomain || sessionStorage.getItem(NOTICE_SHOWN_SESSION_KEY) !== null) {
      return;
    }

    sessionStorage.setItem(NOTICE_SHOWN_SESSION_KEY, "shown");

    toast({
      title: "This site has a new address",
      description: `${legacySubdomain}.${ROOT_DOMAIN} is moving to ${subdomain}.${ROOT_DOMAIN} - please update any bookmarks or links accordingly. Thank you!`,
      duration: 10000, // Radix defaults to 5s, which is short for an address this long.
    });
  }, [toast]);

  return null;
}
